/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: ringGroupsActions.ts (Ring Groups)
 🗓️ Created: 2025-01-15
 🧩 Description:
    Shared helpers for Ring Groups module actions.
    Used in Grid + Form views.

 🔧 Notes:
    - Refactored to use new API layer
    - Navigation helpers for duplicate functionality

 🔁 Last Updated: 2025-01-15 by Rodrigo Cuadra (Refactored)
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteRingGroupById as deleteRingGroupApi } from './api/ringGroupsApi';

/**
 * Build the URL used to duplicate a Ring Group in the form.
 * Pattern: /pbx/call-center/ring-groups/new?duplicate={id}
 */
export const getRingGroupDuplicateUrl = (id: string | number): string =>
  `/pbx/call-center/ring-groups/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given Ring Group id.
 */
export const navigateToRingGroupDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getRingGroupDuplicateUrl(id));
};

/**
 * Delete a Ring Group by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 */
export const deleteRingGroupById = async (id: string | number): Promise<void> => {
  await deleteRingGroupApi(id);
};



